import { Check } from "lucide-react"
import headshotUrl from "@/assets/headshot.png"
import { LeadForm } from "./LeadForm"
import { hero } from "./content"

export function Hero() {
  return (
    <section id="top" data-section="hero" className="border-b border-hairline">
      <div className="mx-auto grid max-w-6xl grid-cols-1 items-start gap-10 px-4 py-16 sm:px-6 sm:py-20 lg:grid-cols-2 lg:gap-16">
        {/* Left: pitch, trust markers, then the headshot. */}
        <div>
          <span className="section-eyebrow">{hero.eyebrow}</span>
          <h1 className="hero-title mt-3">{hero.title}</h1>
          <p className="section-lead mt-5 max-w-xl">{hero.subhead}</p>

          <div className="mt-8 flex items-center gap-5">
            <img
              src={headshotUrl}
              alt="Matthew Traynor, freelance Google Ads consultant"
              width={400}
              height={400}
              className="w-32 shrink-0 rounded-2xl border border-hairline object-cover"
            />
            <ul className="flex flex-col gap-2.5">
              {hero.trust.map((item) => (
                <li key={item} className="flex items-center gap-2">
                  <Check aria-hidden="true" className="h-4 w-4 shrink-0 text-accent-display" />
                  <span className="text-ink-muted">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Right: the lead application form (moved up from its own section). */}
        <div className="mx-auto w-full max-w-md lg:mx-0 lg:max-w-none">
          <LeadForm />
        </div>
      </div>
    </section>
  )
}
